import { render, staticRenderFns } from "./Benefits2.vue?vue&type=template&id=1cee24fb&scoped=true"
import script from "./Benefits2.vue?vue&type=script&lang=js"
export * from "./Benefits2.vue?vue&type=script&lang=js"
import style0 from "./Benefits2.vue?vue&type=style&index=0&id=1cee24fb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cee24fb",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VImg,VListItem,VListItemAvatar,VListItemContent,VRow,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/Users/afonsomonteiro/onboarding/onboarding/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cee24fb')) {
      api.createRecord('1cee24fb', component.options)
    } else {
      api.reload('1cee24fb', component.options)
    }
    module.hot.accept("./Benefits2.vue?vue&type=template&id=1cee24fb&scoped=true", function () {
      api.rerender('1cee24fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Simulador/Benefits2.vue"
export default component.exports